'use client';

import React, { useId } from 'react';
import { useSearchParams } from 'next/navigation';
import SearchIcon from '@icons/search.svg';
import { usePathname, useRouter } from '@/i18n/navigation';

function Search() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const id = useId();

  function handleSearch(query: string) {
    const params = new URLSearchParams(searchParams);
    if (query) {
      params.set('search', query);
    } else {
      params.delete('search');
    }

    router.replace(`${pathname}?${params.toString()}`);
  }

  return (
    <div className='search-form search-form--light'>
      <form
        className='search-form__form'
        onSubmit={e => {
          e.preventDefault();
          const formData = new FormData(e.currentTarget);
          handleSearch(formData.get('search')?.toString() ?? '');
        }}
      >
        <input
          type='search'
          aria-label='Suchbegriff eingeben'
          name='search'
          id={`${id}-search`}
          className='search-form__input'
          placeholder='Suche...'
          defaultValue={searchParams.get('search')?.toString()}
        />
        <button className='search-form__submit' type='submit' aria-label='Suche abschicken'>
          <SearchIcon color='var(--clr-secondary)' />
        </button>
      </form>
    </div>
  );
}

export default Search;
